// 色トーン体系の単一情報源。badge / toast / modal(danger) / notification / カレンダーチップが共有する。
export type Tone = "info" | "success" | "warning" | "danger" | "neutral";

export interface ToneClasses {
  readonly badge: string; // バッジ/チップ
  readonly bar: string; // 帯（modal danger ヘッダ等）
  readonly dot: string; // ステータスドット
  readonly chip: string; // カレンダー等の淡色チップ
}

export const TONE_CLASSES: Record<Tone, ToneClasses> = {
  info: { badge: "bg-blue-100 text-blue-800 border-blue-200", bar: "bg-blue-50 border-blue-200 text-blue-800", dot: "bg-blue-500", chip: "bg-blue-50 text-blue-700" },
  success: { badge: "bg-green-100 text-green-800 border-green-200", bar: "bg-green-50 border-green-200 text-green-800", dot: "bg-green-500", chip: "bg-green-50 text-green-700" },
  warning: { badge: "bg-amber-100 text-amber-800 border-amber-200", bar: "bg-amber-50 border-amber-200 text-amber-800", dot: "bg-amber-500", chip: "bg-amber-50 text-amber-800" },
  danger: { badge: "bg-red-100 text-red-800 border-red-200", bar: "bg-red-50 border-red-200 text-red-800", dot: "bg-red-500", chip: "bg-red-50 text-red-700" },
  neutral: { badge: "bg-slate-100 text-slate-700 border-slate-200", bar: "bg-slate-50 border-slate-200 text-slate-700", dot: "bg-slate-400", chip: "bg-slate-100 text-slate-700" },
};
